export const actions = {
  set_state: 'facebook_pixel/set_state',
  get_facebook_pixel: 'facebook_pixel/get_facebook_pixel',
  get_facebook_pixel_qr: 'facebook_pixel/get_facebook_pixel_qr',
  delete_facebook_pixel: 'facebook_pixel/delete_facebook_pixel',
  create_facebook_pixel: 'facebook_pixel/create_facebook_pixel'
}
